class HotanExpressThemeToggle {
  constructor() {
    this.root = document.documentElement;
    this.systemPreference = window.matchMedia('(prefers-color-scheme: dark)');
    this.buttons = document.querySelectorAll('[data-theme-toggle]');

    // ✅ FIX: استرجاع الثيم المحفوظ عند تحميل الصفحة
    const saved = localStorage.getItem('hotan-theme');
    const prefersDark = this.systemPreference.matches;
    this.apply(saved ? saved : (prefersDark ? 'dark' : 'light'));

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.toggle());
    });

    this.systemPreference.addEventListener('change', (event) => {
      if (!localStorage.getItem('hotan-theme')) {
        this.apply(event.matches ? 'dark' : 'light');
      }
    });
  }

  apply(theme) {
    this.root.dataset.theme = theme;
    this.updateButtons();
  }

  toggle() {
    const theme = this.root.dataset.theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('hotan-theme', theme);
    this.apply(theme);
  }

  updateButtons() {
    const isDark = this.root.dataset.theme === 'dark';
    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(isDark));
      button.setAttribute('aria-label', (isDark ? 'تفعيل الوضع الفاتح' : 'تفعيل الوضع الداكن'));
      // ✅ تحديث الـ data attribute للـ CSS
      button.dataset.dark = String(isDark);
    });
  }
}

class HotanExpressMobileAddToCart {
  constructor(container) {
    this.container = container;
    this.mainButton = container
      .closest('product-info')
      ?.querySelector('.product-form__submit:not(.hotan-mobile-atc__button)');
    this.mobileButton = container.querySelector('.hotan-mobile-atc__button');
    if (!this.mainButton || !this.mobileButton) return;

    this.mobileButton.addEventListener('click', () => this.mainButton.click());
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
    this.sync();
  }

  sync() {
    const label = this.mainButton.querySelector('span')?.textContent?.trim();
    if (label) this.mobileButton.textContent = label;
    this.mobileButton.disabled = this.mainButton.disabled;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HotanExpressThemeToggle();
  document.querySelectorAll('[data-mobile-atc]').forEach((element) => {
    new HotanExpressMobileAddToCart(element);
  });
});
